module.exports = __webpack_public_path__ + "static/hero-cfe6da99a14be83634181f7f139416da.jpg";